import palette from "assets/theme/base/palette";
import Divider from "@mui/material/Divider";
import React, { useEffect, useState } from "react";
import SubscriptionModal from "./SubscriptionModal";
import Card from "@mui/material/Card";
import Icon from "@mui/material/Icon";
import Tooltip from "@mui/material/Tooltip";
import MDBox from "components/MDBox";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";
import MDTypography from "components/MDTypography";
import DataTable from "examples/Tables/DataTable";
import ConfirmDialog from "examples/Dialog/ConfirmDialog";
import {
  Checkbox,
  FormControl,
  FormControlLabel,
  FormGroup,
  MenuItem,
  Select,
  TextField,
  FormLabel,
  Avatar,
  InputAdornment,
  Chip,
  IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import { call } from "services/axiosService/core";
import PropTypes from "prop-types";
import { useMaterialUIController } from "context";
import CircularProgress from "@mui/material/CircularProgress";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";
import Payment from "./payment";
import Coupon from "./Coupon";
import PaymentSetupWrapper from "./PaymentSetupWrapper";
import { setProfile } from "context";
import TermsAndConditionsPDF from "../../assets/pdf/Terms&Conditions.pdf";
import PaymentTermsPDF from "../../assets/pdf/Payment_Terms.pdf";
import { useNavigate } from "react-router-dom";
import BulkUpload from "./BulkUpload";
import { useAuthenticator } from "@aws-amplify/ui-react";
import * as Sentry from "@sentry/browser";
import { useTranslation } from "react-i18next";

const EditChildrenButton = ({ row, handleOpenEditChildModal, t }) => {
  return (
    <Tooltip fontSize="large" title={<h2 style={{}}>{t("toolTips.edit")}</h2>}>
      <MDTypography
        variant="body1"
        color="secondary"
        lineHeight={1}
        sx={{ cursor: "pointer", mx: 1 }}
      >
        <Icon fontSize="medium" color="info" onClick={() => handleOpenEditChildModal(row)}>
          edit
        </Icon>
      </MDTypography>
    </Tooltip>
  );
};

const DeleteChildrenButton = ({ row, handleOpenDeleteModal, t }) => {
  return (
    <Tooltip fontSize="large" title={<h2 style={{}}>{t("toolTips.delete")}</h2>}>
      <MDTypography
        variant="body1"
        color="secondary"
        lineHeight={1}
        sx={{ cursor: "pointer", mx: 1 }}
      >
        <Icon fontSize="medium" color="error" onClick={() => handleOpenDeleteModal(row)}>
          delete
        </Icon>
      </MDTypography>
    </Tooltip>
  );
};

const PaymentButton = ({ row, handleOpenPaymentModal, t }) => {
  return (
    <Tooltip fontSize="large" title={<h2 style={{}}>{t("toolTips.payment")}</h2>}>
      <MDTypography
        variant="body1"
        color="secondary"
        lineHeight={1}
        sx={{ cursor: "pointer", mx: 1 }}
      >
        <Icon fontSize="medium" color="info" onClick={() => handleOpenPaymentModal(row)}>
          payment
        </Icon>
      </MDTypography>
    </Tooltip>
  );
};

const SendInviteButton = ({ row, handleOpenInviteEmailModal, t }) => {
  return (
    <Tooltip fontSize="large" title={<h2 style={{}}>{t("toolTips.email")}</h2>}>
      <MDTypography
        variant="body1"
        color="secondary"
        lineHeight={1}
        sx={{ cursor: "pointer", mx: 1 }}
      >
        <Icon fontSize="medium" color="info" onClick={() => handleOpenInviteEmailModal(row)}>
          email
        </Icon>
      </MDTypography>
    </Tooltip>
  );
};

const ResetPasswordButton = ({ id, ResetPasswordHandler, t }) => {
  return (
    <Tooltip fontSize="large" title={<h2 style={{}}> {t("toolTips.reset_password")}</h2>}>
      <MDTypography
        variant="body1"
        color="secondary"
        lineHeight={1}
        sx={{ cursor: "pointer", mx: 1 }}
      >
        <Icon
          fontSize="medium"
          color="info"
          onClick={() => {
            ResetPasswordHandler(id);
          }}
        >
          lock_reset
        </Icon>
      </MDTypography>
    </Tooltip>
  );
};

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

const addFormSx = { "& .MuiOutlinedInput-root": { borderRadius: "12px", bgcolor: "#fafafa" } };
const selectSx = { borderRadius: "12px", height: "40px", bgcolor: "#fafafa", "& .MuiOutlinedInput-notchedOutline": { borderColor: "rgba(0,0,0,0.23)" }, "&:hover .MuiOutlinedInput-notchedOutline": { borderColor: "rgba(0,0,0,0.87)" }, "&.Mui-focused .MuiOutlinedInput-notchedOutline": { borderColor: "#10b0d5" } };
const circleCloseSx = { position: "absolute", top: 12, right: 12, zIndex: 10, width: 36, height: 36, borderRadius: "50%", bgcolor: "rgba(0,0,0,0.06)", border: "1px solid rgba(0,0,0,0.08)", display: "flex", alignItems: "center", justifyContent: "center", cursor: "pointer", "&:hover": { bgcolor: "rgba(0,0,0,0.1)" } };

// const RequiredLabel = ({ children }) => {
//   const { t } = useTranslation();
//   return (
//     <FormLabel
//       sx={{
//         display: "flex",
//         color: "black",
//         alignItems: "center",
//         margin: "10px auto 2px",
//         fontSize: "1.05rem",
//         fontWeight: 900,
//       }}
//     >
//       <span style={{ color: "red", fontSize: "small", marginRight: "5px" }}>*</span>
//       {children}
//       <span style={{ color: "red", fontSize: "small", marginLeft: "10px" }}>
//         {t("formLabels.required")}
//       </span>
//     </FormLabel>
//   );
// };

const ChildrenTable = ({ childrenDetails, getChildrens, loader, openAddChild, openPayment }) => {
  const { t } = useTranslation();
  const [controller, dispatch] = useMaterialUIController();
  const [children, setchildren] = useState(childrenDetails);
  const [childForPayment, setChildForPayment] = useState({});
  const [openEditModal, setOpenEditModal] = useState(false);
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [openSubscriptionModal, setOpenSubscriptionModal] = useState(false);
  const [subscriptionType, setSubscriptionType] = useState("maxu_yearly");
  const [openAddChildModal, setOpenAddChildModal] = useState(false);
  const [openAddAthleteModal, setOpenAddAthleteModal] = useState(false);
  const [adding, setAdding] = useState("asParent");
  const [openBulkUploadModal, setOpenBulkUploadModal] = useState(openAddChild);
  const [openPaymentModal, setOpenPaymentModal] = useState(false);
  const [openInstructionModal, setOpenInstructionModal] = useState(false);
  const [selectedChild, setSelectedChild] = useState({});
  const [openInviteEmailModal, setOpenInviteEmailModal] = useState(false);
  const [openPaymentSuccessModal, setOpenPaymentSuccessModal] = useState(false);
  const [addNewPaymentMethod, setAddNewPaymentMethod] = useState(false);
  const [openAddPaymentMethodModal, setOpenAddPaymentMethodModal] = useState(false);
  // const [openChildSummaryModal, setOpenChildSummaryModal] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [deleteChildId, setDeleteChildId] = useState();
  const [editChildData, setEditChildData] = useState({});
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [pageNumber, SetPageNumber] = useState(0);
  const [severity, setSeverity] = useState("info");
  const [searchText, setSearchText] = useState("");
  const [openAddLearnerModal, setOpenAddLearnerModal] = useState(false);
  const [deleteLoading, setDeleteLoading] = useState(false);
  const [autoRenewLoading, setAutoRenewLoading] = useState(false);
  const [resetPasswordLoading, setResetPasswordLoading] = useState(false);
  const [selectUserId, setSelectUserId] = useState("");
  const [openResetPasswordDialog, setOpenResetPasswordDialog] = useState(false);
  const [openAutoRenewModal, setOpenAutoRenewModal] = useState(false);
  const [autoRenewChild, setAutoRenewChild] = useState({});
  const { profile, persona } = controller;
  const isSharedAccount = profile.type && profile.type.includes("Shared");
  const navigate = useNavigate();
  const handleOpenAddChildModal = () => setOpenAddChildModal(true);
  const handleOpenAddAthleteModal = () => setOpenAddAthleteModal(true);
  // const handleOpenAddPaymentMethodModal = () => setOpenAddPaymentMethodModal(true);
  const handleCloseAddChildModal = () => setOpenAddChildModal(false);
  const handleCloseAddAthleteModal = () => setOpenAddAthleteModal(false);
  const handleCloseEditModal = () => setOpenEditModal(false);
  const handleCloseDeleteModal = () => setOpenDeleteModal(false);
  // const handleCloseChildSummaryModal = () => setOpenChildSummaryModal(false);

  const handleCloseAddPaymentMethodModal = async () => {
    await updateUserProfile();
    if (profile.id == childForPayment.id) {
      navigate("/mylearnerdashboard", { state: true });
    }
    setOpenAddPaymentMethodModal(false);
    setChildForPayment({});
    setOpenInstructionModal(true);
  };

  const handleClosePaymentSuccessModal = (shouldAdd = false) => {
    setOpenPaymentSuccessModal(false);
    if (shouldAdd) {
      setOpenAddPaymentMethodModal(true);
    } else if (profile.id == childForPayment.id) {
      navigate("/mylearnerdashboard", { state: true });
    } else {
      setOpenInstructionModal(true);
    }
  };

  const handleCloseSnackbar = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenSnackbar(false);
  };

  const handleCloseInstructionModal = () => {
    setOpenInstructionModal(false);
  };

  const handleCloseSubscriptionModal = (sub) => {
    setSubscriptionType(sub);
    setOpenSubscriptionModal(false);
    setOpenPaymentModal(true);
    // if (childForPayment.is_demo_user) {
    //   updateChildPaymentStatus(childForPayment);
    // } else {
    //   setOpenPaymentModal(true);
    // }
  };

  const handleClosePaymentModal = async (payment_status, shouldAdd = false) => {
    await updateUserProfile();
    setOpenPaymentModal(false);
    if (payment_status == "success") {
      setOpenPaymentSuccessModal(true);
    } else if (payment_status == "PaymentNotRequired") {
      handleClosePaymentSuccessModal(shouldAdd);
    }
    getChildrens();
  };

  const handleOpenEditChildModal = (child) => {
    setEditChildData(child);
    setOpenEditModal(true);
  };

  const handleOpenDeleteModal = (child) => {
    setDeleteChildId(child.id);
    setOpenDeleteModal(true);
  };

  // const handleOpenChildSummaryModal = () => {
  //   setOpenChildSummaryModal(true);
  // };

  // const handleOpenSubscriptionModal = (child) => {
  //   setChildForPayment(child);
  //   setOpenSubscriptionModal(true);
  // };

  const handleOpenInstructionModal = (child) => {
    setOpenAddAthleteModal(false);
    setOpenAddChildModal(false);
    setOpenInstructionModal(true);
    // setChildForPayment(child);
  };

  const handleOpenBulkUploadModal = (option) => {
    if (option == "asCoach") {
      setAdding("asCoach");
      setOpenBulkUploadModal(true);
    } else {
      setAdding("asParent");
      setOpenBulkUploadModal(true);
    }
  };

  const handleCloseBulkUploadModal = () => {
    setOpenBulkUploadModal(false);
    setAdding("asParent");
  };

  const updateChildPaymentStatus = (LearnerDetails) => {
    LearnerDetails.payment_status = "success";
    LearnerDetails.paid_at = new Date();
    LearnerDetails.is_demo_user = true;
    LearnerDetails.subscription_type = subscriptionType;
    call(`users/${LearnerDetails.id}`, "PUT", {
      body: LearnerDetails,
      headers: { "Content-Type": "application/json" },
    })
      .then((response) => {
        if (response.status == 200) {
          getChildrens();
          setOpenInstructionModal(true);
        }
      })
      .catch(function (error) {
        Sentry.captureException(error);
        console.log(error);
      });
  };

  const handleOpenPaymentModal = (child) => {
    setOpenAddChildModal(false);
    setOpenAddAthleteModal(false);
    setChildForPayment(child);
    if (profile.true_mindsets) {
      setOpenSubscriptionModal(true);
    } else {
      setOpenPaymentModal(true);
      // if (child.is_demo_user) {
      //   updateChildPaymentStatus(child);
      // } else {
      //   setOpenPaymentModal(true);
      // }
    }
  };

  const handleOpenInviteEmailModal = (child) => {
    setOpenInviteEmailModal(true);
    setSelectedChild(child);
  };

  const handleCloseInviteEmailModal = () => {
    setOpenInviteEmailModal(false);
    setSelectedChild({});
  };

  const updateUserProfile = () => {
    call(`users/${profile.id}`, "GET", {
      body: profile,
      headers: { "Content-Type": "application/json" },
    })
      .then((response) => {
        if (response.status == 200) {
          setProfile(dispatch, response.data);
        }
      })
      .catch((err) => {
        Sentry.captureException(err);
        console.log(err, "err");
      });
  };

  const CloseResetPasswordDialogHandler = () => {
    setOpenResetPasswordDialog(false);
    // setSelectedId("");
  };

  const ResetPasswordHandler = (id) => {
    setSelectUserId(id);
    setOpenResetPasswordDialog(true);
  };

  const handleSharedAccountDelete = () => {
    setAlertMessage(t("alerts.profile.sharedAccountDeleteNotAvailable"));
    setSeverity("info");
    setOpenSnackbar(true);
  };

  const handleOpenAutoRenewModal = (child) => {
    setAutoRenewChild(child);
    setOpenAutoRenewModal(true);
  };

  const handleCloseAutoRenewModal = () => {
    setAutoRenewChild({});
    setOpenAutoRenewModal(false);
  };

  // ── Inline confirm handlers (used by ConfirmDialog) ──
  const handleDeleteChild = () => {
    setDeleteLoading(true);
    call(`users/${deleteChildId}`, "DELETE", { params: { type: "children" } })
      .then((response) => {
        if (response.status === 200) {
          getChildrens();
          updateUserProfile();
          setSeverity("success");
          setOpenSnackbar(true);
          setAlertMessage(t("alerts.profile.childDeletedSuccessfully"));
          handleCloseDeleteModal();
        } else if (response.status === 440) {
          handleCloseDeleteModal();
        } else {
          setSeverity("error");
          setOpenSnackbar(true);
          setAlertMessage(t("alerts.profile.childDeletedError"));
        }
      })
      .catch((error) => {
        Sentry.captureException(error);
        setSeverity("error");
        setOpenSnackbar(true);
        setAlertMessage(t("alerts.profile.childDeletedError"));
        handleCloseDeleteModal();
      })
      .finally(() => setDeleteLoading(false));
  };

  const autoRenewWillEnable = !(autoRenewChild.auto_renew ?? true);
  const autoRenewChildName =
    (autoRenewChild.type?.includes("Shared") && autoRenewChild.details?.learner_details?.name) ||
    autoRenewChild.details?.name || "";

  const handleConfirmAutoRenew = () => {
    setAutoRenewLoading(true);
    autoRenewChild.auto_renew = autoRenewWillEnable;
    call(`users/${autoRenewChild.id}`, "PUT", { body: autoRenewChild, headers: { "Content-Type": "application/json" } })
      .then((response) => {
        if (response.status === 200) {
          setSeverity("success");
          setAlertMessage(autoRenewWillEnable ? t("alerts.profile.autoRenewEnabled") : t("alerts.profile.autoRenewDisabled"));
          setOpenSnackbar(true);
          getChildrens();
          handleCloseAutoRenewModal();
        } else if (response.status === 440) {
          handleCloseAutoRenewModal();
        } else {
          setSeverity("error");
          setAlertMessage(t("alerts.profile.autoRenewError"));
          setOpenSnackbar(true);
        }
      })
      .catch((error) => {
        Sentry.captureException(error);
        setSeverity("error");
        setAlertMessage(t("alerts.profile.autoRenewError"));
        setOpenSnackbar(true);
        handleCloseAutoRenewModal();
      })
      .finally(() => setAutoRenewLoading(false));
  };

  const handleConfirmResetPassword = () => {
    setResetPasswordLoading(true);
    call(`users/${selectUserId}/resetpassword`, "POST", {})
      .then((res) => {
        if (res.status === 200) {
          setOpenSnackbar(true);
          setAlertMessage(`Reset Password successful — New Password: ${res.data.new_password}`);
        } else if (res.status === 404) {
          setOpenSnackbar(true);
          setAlertMessage("Error while resetting the password");
        }
        CloseResetPasswordDialogHandler();
      })
      .catch((err) => {
        Sentry.captureException(err);
        CloseResetPasswordDialogHandler();
      })
      .finally(() => setResetPasswordLoading(false));
  };

  useEffect(() => {
    if (openPayment) {
      handleOpenPaymentModal(profile);
    }
  }, []);

  // ── Build styled rows for DataTable ──
  function formatToMMDDYYYY(dateStr) {
    if (!dateStr) return "–";
    const [year, month, day] = dateStr.split("-");
    return `${month}-${day}-${year}`;
  }

  const statusChipEl = (rawStatus) => {
    const map = { active: { bg: "#e8f5e9", color: "#4caf50" }, inactive: { bg: "#f5f5f5", color: "#9e9e9e" }, pending: { bg: "#fff3e0", color: "#ff9800" } };
    const c = map[rawStatus?.toLowerCase()] || map.inactive;
    return <Chip label={t(`userDynamicData.${rawStatus}`) || rawStatus} size="small" sx={{ bgcolor: c.bg, color: c.color, fontWeight: "bold", fontSize: "0.68rem", height: 22 }} />;
  };

  const paymentChipEl = (rawStatus) => {
    const map = { success: { bg: "#e8f5e9", color: "#4caf50" }, pending: { bg: "#fff3e0", color: "#ff9800" }, failed: { bg: "#fdecea", color: "#f44336" } };
    const c = map[rawStatus?.toLowerCase()] || map.pending;
    return <Chip label={t(`userDynamicData.${rawStatus}`) || rawStatus} size="small" sx={{ bgcolor: c.bg, color: c.color, fontWeight: "bold", fontSize: "0.68rem", height: 22 }} />;
  };

  const filteredDetails = childrenDetails.filter((row) => {
    const q = searchText.toLowerCase();
    if (!q) return true;
    const isShared = row.type && row.type.includes("Shared");
    const details = isShared && row.details.learner_details ? row.details.learner_details : row.details;
    return (
      details?.name?.toLowerCase().includes(q) ||
      row.email?.toLowerCase().includes(q)
    );
  });

  const childrenData = {
    columns: [
      { Header: t("tableHeaders.name"), accessor: "name", width: "18%" },
      { Header: t("tableHeaders.relation"), accessor: "relation", width: "10%" },
      { Header: t("tableHeaders.email"), accessor: "email", width: "18%" },
      { Header: t("tableHeaders.gender"), accessor: "gender", width: "8%", align: "center" },
      { Header: t("tableHeaders.dob"), accessor: "dob", width: "10%" },
      { Header: t("tableHeaders.status"), accessor: "status", width: "9%" },
      { Header: t("tableHeaders.payment_status"), accessor: "payment_status", width: "15%", align: "center" },
      { Header: t("tableHeaders.auto_renew"), accessor: "auto_renew", width: "9%", align: "center" },
      { Header: t("tableHeaders.actions"), accessor: "actions", width: "10%" },
    ],
    rows: filteredDetails.map((row) => {
      const isShared = row.type && row.type.includes("Shared");
      const details = isShared && row.details.learner_details ? row.details.learner_details : row.details;
      const displayName = isShared
        ? details.name + " (" + t("userDynamicData.shared") + ")"
        : row.id === profile.id
        ? details.name + " (" + t("userDynamicData.owner") + ")"
        : details.name;
      const canEdit = ((!row.is_adult && row.id !== profile.id && !isShared) || (isShared && row.id === profile.id));

      return {
        id: row.id,
        name: (
          <MDBox display="flex" alignItems="center" gap={1.5}>
            <Avatar src={row.profile_image_url || ""} sx={{ width: 32, height: 32, bgcolor: palette.brand[50] }}>
              <Icon sx={{ fontSize: "16px !important", color: palette.brand[400] }}>person</Icon>
            </Avatar>
            <MDTypography variant="caption" fontWeight="medium">{displayName}</MDTypography>
          </MDBox>
        ),
        relation: (
          <MDTypography variant="caption" color="text.secondary">
            {row.relation ? t(`userDynamicData.${row.relation.toLowerCase()}`) : "–"}
          </MDTypography>
        ),
        email: (
          <MDTypography variant="caption" color="text.secondary" sx={{ maxWidth: 160, display: "block", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
            {row.email || "–"}
          </MDTypography>
        ),
        gender: (
          <MDTypography variant="caption" color="text.secondary">
            {details.gender ? t(`userDynamicData.${details.gender.toLowerCase()}`) : "–"}
          </MDTypography>
        ),
        dob: (
          <MDTypography variant="caption" color="text.secondary">{formatToMMDDYYYY(details.dob)}</MDTypography>
        ),
        status: statusChipEl(row.status),
        payment_status: paymentChipEl(row.payment_status),
        auto_renew: (
          <Tooltip title={t("toolTips.autoRenew")}>
            <div style={{ display: "inline-flex", borderRadius: "20px", overflow: "hidden", border: "1px solid #ccc", userSelect: "none", width: "72px", height: "28px" }}>
              <span
                onClick={() => !(row.auto_renew ?? true) && handleOpenAutoRenewModal(row)}
                style={{ flex: 1, display: "flex", alignItems: "center", justifyContent: "center", fontSize: "11px", fontWeight: "bold", backgroundColor: (row.auto_renew ?? true) ? palette.brand[500] : palette.neutral[100], color: (row.auto_renew ?? true) ? palette.white : palette.neutral[400], cursor: (row.auto_renew ?? true) ? "default" : "pointer" }}
              >ON</span>
              <span
                onClick={() => (row.auto_renew ?? true) && handleOpenAutoRenewModal(row)}
                style={{ flex: 1, display: "flex", alignItems: "center", justifyContent: "center", fontSize: "11px", fontWeight: "bold", backgroundColor: (row.auto_renew ?? true) ? palette.neutral[100] : palette.brand[500], color: (row.auto_renew ?? true) ? palette.neutral[400] : palette.white, cursor: (row.auto_renew ?? true) ? "pointer" : "default" }}
              >OFF</span>
            </div>
          </Tooltip>
        ),
        actions: (
          <MDBox display="flex" alignItems="center">
            {canEdit && (
              <Tooltip title={t("toolTips.edit")}>
                <IconButton size="small" onClick={() => handleOpenEditChildModal(row)} sx={{ color: palette.brand[500] }}>
                  <Icon fontSize="small">edit</Icon>
                </IconButton>
              </Tooltip>
            )}
            {canEdit && !isShared && (
              <Tooltip title={t("toolTips.delete")}>
                <IconButton size="small" onClick={() => handleOpenDeleteModal(row)} sx={{ color: "#f44336" }}>
                  <Icon fontSize="small">delete</Icon>
                </IconButton>
              </Tooltip>
            )}
            {row.payment_status !== "success" && (
              <Tooltip title={t("toolTips.payment")}>
                <IconButton size="small" onClick={() => handleOpenPaymentModal(row)} sx={{ color: "#4caf50" }}>
                  <Icon fontSize="small">payment</Icon>
                </IconButton>
              </Tooltip>
            )}
            {row.status !== "active" && (
              <Tooltip title={t("toolTips.email")}>
                <IconButton size="small" onClick={() => handleOpenInviteEmailModal(row)} sx={{ color: "#ff9800" }}>
                  <Icon fontSize="small">email</Icon>
                </IconButton>
              </Tooltip>
            )}
            {row.status !== "active" && row.cognito_user_id && (
              <Tooltip title={t("toolTips.reset_password")}>
                <IconButton size="small" onClick={() => ResetPasswordHandler(row.id)} sx={{ color: "#9c27b0" }}>
                  <Icon fontSize="small">lock_reset</Icon>
                </IconButton>
              </Tooltip>
            )}
          </MDBox>
        ),
      };
    }),
  };

  return (
    <>
      {/* ── Section header ── */}
      <MDBox display="flex" alignItems="center" justifyContent="space-between" mb={2} flexWrap="wrap" gap={2}>
        <MDBox display="flex" alignItems="center" gap={1.5}>
          <MDBox
            sx={{
              width: 40, height: 40, borderRadius: "10px",
              bgcolor: `${palette.brand[500]}18`,
              display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0,
            }}
          >
            <Icon sx={{ color: palette.brand[500], fontSize: "22px !important" }}>supervisor_account</Icon>
          </MDBox>
          <MDBox>
            <MDTypography variant="h5" fontWeight="bold">{t("headings.learners")}</MDTypography>
            <MDTypography variant="body2" color="text.secondary">
              Manage children/athletes linked to your account.
            </MDTypography>
          </MDBox>
        </MDBox>
        <MDBox display="flex" alignItems="center" gap={1.5} flexWrap="wrap">
          <MDInput
            size="small"
            placeholder="Search learners..."
            value={searchText}
            onChange={(e) => setSearchText(e.target.value)}
            sx={{ minWidth: 200 }}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <Icon sx={{ fontSize: "18px !important" }}>search</Icon>
                </InputAdornment>
              ),
            }}
          />
          {!isSharedAccount && (
            <Button
              variant="contained"
              startIcon={<Icon>person_add</Icon>}
              onClick={() => setOpenAddLearnerModal(true)}
              sx={{
                bgcolor: palette.brand[500], color: "#fff",
                borderRadius: "12px", textTransform: "none", fontWeight: "bold",
                px: 3.5, py: 1.5, fontSize: "0.95rem", boxShadow: "none",
                "&:hover": { bgcolor: palette.brand[600], boxShadow: "none" },
              }}
            >
              {t("buttonTitles.addLearner") || "Add Learner"}
            </Button>
          )}
        </MDBox>
      </MDBox>

      {/* ── DataTable ── */}
      <DataTable
        table={childrenData}
        loader={loader}
        pageNumber={pageNumber}
        SetPageNumber={SetPageNumber}
        noData={true}
        canSearch={false}
      />

      {/* ── Add Learner Role Picker ── */}
      {openAddLearnerModal && (
        <AddLearnerRolePickerModal
          open={openAddLearnerModal}
          onClose={() => setOpenAddLearnerModal(false)}
          onSelectParent={() => { setOpenAddLearnerModal(false); handleOpenBulkUploadModal("asParent"); }}
          onSelectCoach={() => { setOpenAddLearnerModal(false); handleOpenBulkUploadModal("asCoach"); }}
          t={t}
        />
      )}

      {openAddChildModal && (
        <AddChildModal
          openAddChildModal={openAddChildModal}
          handleCloseAddChildModal={handleCloseAddChildModal}
          getChildrens={getChildrens}
          updateUserProfile={updateUserProfile}
          handleOpenPaymentModal={handleOpenPaymentModal}
          handleOpenInstructionModal={handleOpenInstructionModal}
          setOpenAddChildModal={setOpenAddChildModal}
          profile={profile}
          setOpenSnackbar={setOpenSnackbar}
          setAlertMessage={setAlertMessage}
          setSeverity={setSeverity}
          t={t}
        />
      )}

      {openAddAthleteModal && (
        <AddAthleteModal
          openAddAthleteModal={openAddAthleteModal}
          handleCloseAddAthleteModal={handleCloseAddAthleteModal}
          getChildrens={getChildrens}
          updateUserProfile={updateUserProfile}
          handleOpenPaymentModal={handleOpenPaymentModal}
          handleOpenInstructionModal={handleOpenInstructionModal}
          setOpenAddAthleteModal={setOpenAddAthleteModal}
          profile={profile}
          setOpenSnackbar={setOpenSnackbar}
          setAlertMessage={setAlertMessage}
          setSeverity={setSeverity}
          t={t}
        />
      )}

      {openEditModal && (
        <EditChildModal
          openEditModal={openEditModal}
          handleCloseEditModal={handleCloseEditModal}
          editChildData={editChildData}
          getChildrens={getChildrens}
          setOpenSnackbar={setOpenSnackbar}
          setAlertMessage={setAlertMessage}
          setSeverity={setSeverity}
          t={t}
        />
      )}

      {openDeleteModal && (
        <ConfirmDialog
          open={openDeleteModal}
          onClose={handleCloseDeleteModal}
          onConfirm={handleDeleteChild}
          title={t("headings.removeChild")}
          message={t("messages.profile.removeChild")}
          confirmLabel={t("buttonTitles.remove")}
          cancelLabel={t("buttonTitles.cancel") || "Cancel"}
          dangerous
          loading={deleteLoading}
          icon="person_remove"
        />
      )}

      {openInstructionModal && (
        <InstructionModal
          openInstructionModal={openInstructionModal}
          handleCloseInstructionModal={handleCloseInstructionModal}
          t={t}
        />
      )}

      {openSubscriptionModal && (
        <MAXUSubscriptionModal
          openSubscriptionModal={openSubscriptionModal}
          handleCloseSubscriptionModal={handleCloseSubscriptionModal}
          subscriptionType={subscriptionType}
          setSubscriptionType={setSubscriptionType}
        />
      )}

      {openPaymentModal && (
        <PaymentModal
          openPaymentModal={openPaymentModal}
          handleClosePaymentModal={handleClosePaymentModal}
          childDetails={childForPayment}
          subscriptionType={subscriptionType}
          t={t}
        />
      )}

      {openAddPaymentMethodModal && (
        <PaymentSetupWrapper
          openAddPaymentMethodModal={openAddPaymentMethodModal}
          handleCloseAddPaymentMethodModal={handleCloseAddPaymentMethodModal}
          setOpenSnackbar={setOpenSnackbar}
          setAlertMessage={setAlertMessage}
          setSeverity={setSeverity}
          addNewPaymentMethod={addNewPaymentMethod}
          childDetails={childForPayment}
          t={t}
        />
      )}

      {openPaymentSuccessModal && (
        <PaymentSuccessModal
          openPaymentSuccessModal={openPaymentSuccessModal}
          handleClosePaymentSuccessModal={handleClosePaymentSuccessModal}
          t={t}
        />
      )}
      {/* {openChildSummaryModal && (
        <ChildSummaryModal
          openChildSummaryModal={openChildSummaryModal}
          handleCloseChildSummaryModal={handleCloseChildSummaryModal}
          profile={profile}
          setOpenSnackbar={setOpenSnackbar}
          setAlertMessage={setAlertMessage}
          setSeverity={setSeverity}
          t={t}
        />
      )} */}

      {openBulkUploadModal && (
        <BulkUpload
          adding={adding}
          trueMindsUser={profile.true_mindsets}
          setOpenAddAthleteModal={setOpenAddAthleteModal}
          setOpenAddChildModal={setOpenAddChildModal}
          handleCloseBulkUploadModal={handleCloseBulkUploadModal}
          getChildrens={getChildrens}
          updateUserProfile={updateUserProfile}
          setOpenSnackbar={setOpenSnackbar}
          setAlertMessage={setAlertMessage}
          setSeverity={setSeverity}
          setProfile={setProfile}
          t={t}
        />
      )}

      {openInviteEmailModal && (
        <SendInviteEmailModal
          selectedChild={selectedChild}
          handleCloseInviteEmailModal={handleCloseInviteEmailModal}
          setOpenSnackbar={setOpenSnackbar}
          setAlertMessage={setAlertMessage}
          setSeverity={setSeverity}
          profile={profile}
          t={t}
        />
      )}

      {openResetPasswordDialog && (
        <ConfirmDialog
          open={openResetPasswordDialog}
          onClose={CloseResetPasswordDialogHandler}
          onConfirm={handleConfirmResetPassword}
          title={t("resetPassword.title")}
          message={t("resetPassword.message")}
          confirmLabel={t("buttonTitles.reset")}
          cancelLabel={t("buttonTitles.close")}
          loading={resetPasswordLoading}
          icon="lock_reset"
          iconColor="#9c27b0"
        />
      )}

      {openAutoRenewModal && (
        <ConfirmDialog
          open={openAutoRenewModal}
          onClose={handleCloseAutoRenewModal}
          onConfirm={handleConfirmAutoRenew}
          title={t("headings.autoRenew")}
          message={
            autoRenewWillEnable
              ? t("messages.profile.autoRenewEnable", { name: autoRenewChildName })
              : t("messages.profile.autoRenewDisable", { name: autoRenewChildName })
          }
          confirmLabel={t("buttonTitles.yes")}
          cancelLabel={t("buttonTitles.no")}
          loading={autoRenewLoading}
          icon="autorenew"
          iconColor={autoRenewWillEnable ? "#4caf50" : "#f44336"}
        />
      )}

      <Snackbar
        autoHideDuration={4000}
        open={openSnackbar}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      >
        <Alert onClose={handleCloseSnackbar} severity={severity} sx={{ width: "100%" }}>
          {alertMessage}
        </Alert>
      </Snackbar>
    </>
  );
};

const SendInviteEmailModal = ({
  selectedChild,
  handleCloseInviteEmailModal,
  setOpenSnackbar,
  setAlertMessage,
  setSeverity,
  profile,
  t,
}) => {
  const { signOut } = useAuthenticator((context) => [context.user]);
  const email = selectedChild.email;
  const recipient_id = selectedChild.id;

  const onSendEmail = () => {
    call(`users/${profile.id}/emails`, "POST", {
      body: { email_type: "send_signup_reminder_notification", recipient_id: recipient_id },
    })
      .then((response) => {
        if (response.status == 200) {
          setAlertMessage(t("alerts.dashboard.insightReminderSuccess"));
          setOpenSnackbar(true);
          setSeverity("success");
          handleCloseInviteEmailModal();
        } else {
          setAlertMessage(t("alerts.dashboard.insightReminderError"));
          setOpenSnackbar(true);
          setSeverity("error");
          handleCloseInviteEmailModal();
        }
      })
      .catch(function (err) {
        setAlertMessage(t("alerts.dashboard.insightReminderError"));
        setOpenSnackbar(true);
        setSeverity("error");
        handleCloseInviteEmailModal();
        console.log(err);
        Sentry.captureException(err);
      });
  };

  // const onCreateChildAccount = async () => {
  //   await signOut();
  // };

  const steps = [
    { icon: "login",      text: t("childSignupInstruction.step1") },
    { icon: "email",      text: t("childSignupInstruction.step2") },
    { icon: "lock_reset", text: t("childSignupInstruction.step3") },
  ];

  return (
    <Dialog open={true} onClose={handleCloseInviteEmailModal} fullWidth maxWidth="sm"
      PaperProps={{ sx: { borderRadius: "24px", overflow: "hidden", maxHeight: "90vh" } }}>
      <MDBox sx={{ overflowY: "auto", maxHeight: "90vh" }}>

      {/* Circle close */}
      <MDBox onClick={handleCloseInviteEmailModal} sx={{ position: "absolute", top: 12, right: 12, zIndex: 10, width: 36, height: 36, borderRadius: "50%", bgcolor: palette.neutral[100], border: `1px solid ${palette.neutral[200]}`, display: "flex", alignItems: "center", justifyContent: "center", cursor: "pointer", "&:hover": { bgcolor: palette.neutral[200] } }}>
        <Icon sx={{ fontSize: "18px !important", color: palette.neutral[600] }}>close</Icon>
      </MDBox>

      <MDBox sx={{ px: 4, pt: 5, pb: 4 }}>
        {/* Header */}
        <MDBox textAlign="center" mb={3}>
          <MDBox sx={{ position: "relative", display: "inline-flex", mb: 2 }}>
            <MDBox sx={{ position: "absolute", top: -10, left: -18, color: palette.brand[400], fontSize: "18px", lineHeight: 1 }}>✦</MDBox>
            <MDBox sx={{ position: "absolute", bottom: 0, left: -12, color: "#f48326", fontSize: "10px", lineHeight: 1 }}>●</MDBox>
            <MDBox sx={{ position: "absolute", top: 2, right: -20, color: "#9c27b0", fontSize: "10px", lineHeight: 1 }}>●</MDBox>
            <MDBox sx={{ position: "absolute", bottom: -8, right: -16, color: palette.brand[400], fontSize: "14px", lineHeight: 1 }}>✦</MDBox>
            <MDBox sx={{ width: 90, height: 90, borderRadius: "50%", bgcolor: `${palette.brand[500]}18`, display: "flex", alignItems: "center", justifyContent: "center" }}>
              <Icon sx={{ fontSize: "48px !important", color: palette.brand[500] }}>forward_to_inbox</Icon>
            </MDBox>
          </MDBox>
          <MDTypography variant="h5" fontWeight="bold" mb={0.5}>
            {t("childSignupInstruction.title")}
          </MDTypography>
          <MDTypography variant="body2" color="text.secondary" sx={{ lineHeight: 1.6 }}>
            {t("childSignupInstruction.thankYou")}
          </MDTypography>
        </MDBox>

        {/* Email highlight */}
        <MDBox display="flex" alignItems="center" gap={1.5}
          sx={{ bgcolor: `${palette.brand[500]}0a`, border: `1px solid ${palette.brand[200]}`, borderRadius: "12px", p: 2, mb: 2.5 }}>
          <MDBox sx={{ width: 36, height: 36, borderRadius: "10px", bgcolor: `${palette.brand[500]}18`, display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
            <Icon sx={{ color: palette.brand[500], fontSize: "18px !important" }}>alternate_email</Icon>
          </MDBox>
          <MDBox>
            <MDTypography variant="caption" color="text.secondary" display="block">Invitation will be sent to</MDTypography>
            <MDTypography variant="body2" fontWeight="bold" sx={{ color: palette.brand[600] }}>{email}</MDTypography>
          </MDBox>
        </MDBox>

        {/* Steps */}
        <MDTypography variant="body2" fontWeight="bold" mb={1.5}>{t("childSignupInstruction.instructionsTitle")}</MDTypography>
        <MDBox sx={{ border: `1px solid ${palette.neutral[200]}`, borderRadius: "16px", overflow: "hidden", mb: 2.5 }}>
          {steps.map((step, i) => (
            <MDBox key={i}>
              <MDBox display="flex" alignItems="flex-start" gap={2} px={2.5} py={1.75}>
                <MDBox sx={{ width: 36, height: 36, borderRadius: "10px", bgcolor: `${palette.brand[500]}18`, display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0, mt: 0.1 }}>
                  <Icon sx={{ color: palette.brand[500], fontSize: "18px !important" }}>{step.icon}</Icon>
                </MDBox>
                <MDBox display="flex" alignItems="flex-start" gap={1.5} flex={1}>
                  <MDBox sx={{ width: 22, height: 22, borderRadius: "50%", bgcolor: palette.brand[500], display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0, mt: 0.15 }}>
                    <MDTypography variant="caption" fontWeight="bold" sx={{ color: "#fff", fontSize: "0.65rem" }}>{i + 1}</MDTypography>
                  </MDBox>
                  <MDTypography variant="body2" sx={{ lineHeight: 1.6, color: "text.secondary", pt: 0.1 }}>{step.text}</MDTypography>
                </MDBox>
              </MDBox>
              {i < steps.length - 1 && <Divider sx={{ m: 0 }} />}
            </MDBox>
          ))}
        </MDBox>

        {/* Assessment ready */}
        <MDBox display="flex" alignItems="flex-start" gap={1.5}
          sx={{ bgcolor: "#e8f5e9", border: "1px solid #a5d6a7", borderRadius: "12px", p: 2, mb: 2.5 }}>
          <Icon sx={{ color: "#4caf50", fontSize: "20px !important", flexShrink: 0, mt: 0.1 }}>check_circle</Icon>
          <MDTypography variant="caption" sx={{ color: "#1b5e20", lineHeight: 1.6 }}>
            {t("childSignupInstruction.assessmentReady")}
          </MDTypography>
        </MDBox>

        {/* Note */}
        <MDBox display="flex" alignItems="flex-start" gap={1.5}
          sx={{ bgcolor: "#fff8e1", border: "1px solid #ffe082", borderRadius: "12px", p: 2, mb: 3 }}>
          <Icon sx={{ color: "#f9a825", fontSize: "20px !important", flexShrink: 0, mt: 0.1 }}>info</Icon>
          <MDTypography variant="caption" sx={{ color: "#6d4c00", lineHeight: 1.6 }}
            dangerouslySetInnerHTML={{ __html: t("childSignupInstruction.note") }} />
        </MDBox>

        {/* Buttons */}
        <MDBox display="flex" gap={2}>
          <MDButton variant="outlined" fullWidth onClick={handleCloseInviteEmailModal}
            sx={{ borderRadius: "12px", py: 1.5, textTransform: "none", borderColor: palette.neutral[300], color: palette.neutral[600], fontWeight: "bold" }}>
            {t("buttonTitles.close")}
          </MDButton>
          <MDButton variant="contained" fullWidth onClick={onSendEmail}
            sx={{ borderRadius: "12px", py: 1.5, textTransform: "none", bgcolor: palette.brand[500], color: "#fff", fontWeight: "bold", "&:hover": { bgcolor: palette.brand[600] } }}>
            <Icon sx={{ mr: 1, fontSize: "18px !important" }}>send</Icon>
            {t("childSignupInstruction.sendEmailBtn")}
          </MDButton>
        </MDBox>
      </MDBox>
      </MDBox>
    </Dialog>
  );
};
const MAXUSubscriptionModal = ({
  openSubscriptionModal,
  handleCloseSubscriptionModal,
  subscriptionType,
  setSubscriptionType,
}) => {
  return (
    <Dialog open={openSubscriptionModal}>
      <DialogContent>
        <SubscriptionModal isOpen={true} onClose={handleCloseSubscriptionModal} />
      </DialogContent>
    </Dialog>
  );
};

const InstructionModal = ({ openInstructionModal, handleCloseInstructionModal, t }) => (
  <Dialog open={openInstructionModal} onClose={handleCloseInstructionModal} fullWidth maxWidth="sm"
    PaperProps={{ sx: { borderRadius: "24px", overflow: "hidden", maxHeight: "90vh" } }}>

    <MDBox onClick={handleCloseInstructionModal} sx={circleCloseSx}>
      <Icon sx={{ fontSize: "18px !important", color: palette.neutral[600] }}>close</Icon>
    </MDBox>

    <MDBox sx={{ overflowY: "auto" }}>
      <MDBox sx={{ px: 4, pt: 5, pb: 4 }}>
        <MDBox textAlign="center" mb={3}>
          <MDBox sx={{ position: "relative", display: "inline-flex", mb: 2 }}>
            <MDBox sx={{ position: "absolute", top: -10, left: -18, color: "#4caf50", fontSize: "18px", lineHeight: 1 }}>✦</MDBox>
            <MDBox sx={{ position: "absolute", bottom: 0, left: -12, color: "#f48326", fontSize: "10px", lineHeight: 1 }}>●</MDBox>
            <MDBox sx={{ position: "absolute", top: 2, right: -20, color: "#9c27b0", fontSize: "10px", lineHeight: 1 }}>●</MDBox>
            <MDBox sx={{ position: "absolute", bottom: -8, right: -16, color: "#4caf50", fontSize: "14px", lineHeight: 1 }}>✦</MDBox>
            <MDBox sx={{ width: 90, height: 90, borderRadius: "50%", bgcolor:  palette.orange[50], display: "flex", alignItems: "center", justifyContent: "center" }}>
              <Icon sx={{ fontSize: "48px !important", color:  palette.orange[500] }}>how_to_reg</Icon>
            </MDBox>
          </MDBox>
          <MDTypography variant="h5" fontWeight="bold" mb={0.75}>{t("headings.accountSetupInstructions")}</MDTypography>
        </MDBox>

        <MDBox sx={{ border: `1px solid ${palette.neutral[200]}`, borderRadius: "16px", p: 2.5, mb: 3 }}>
          <Typography variant="body2" sx={{ lineHeight: 1.8, color: "text.secondary" }}
            dangerouslySetInnerHTML={{ __html: t("messages.subscription.thankyouMessageChild") }} />
        </MDBox>

        <MDButton variant="contained" fullWidth onClick={handleCloseInstructionModal}
          sx={{ borderRadius: "12px", py: 1.5, textTransform: "none", bgcolor: palette.brand[500], color: "#fff", fontWeight: "bold", "&:hover": { bgcolor: palette.brand[600] } }}>
          {t("buttonTitles.close")}
        </MDButton>
      </MDBox>
    </MDBox>
  </Dialog>
);
const PaymentModal = ({
  openPaymentModal,
  childDetails,
  handleClosePaymentModal,
  subscriptionType,
  t,
}) => {
  const [controller] = useMaterialUIController();
  const { profile } = controller;
  const [amountToProcess, setAmountToProcess] = useState(
    subscriptionType == "true_mindsets_yearly"
      ? 480
      : subscriptionType == "true_mindsets_monthly"
      ? 45
      : 99
  );
  const [proceedToPayment, setProceedtoPayment] = useState(false);
  const [couponUsed, setCouponUsed] = useState(null);

  const feeLabel = subscriptionType === "maxu_yearly"
    ? (profile.id === childDetails?.id
        ? t("messages.subscription.maxuAnnualFee", { amount: amountToProcess })
        : t("messages.subscription.maxuAnnualFeeChild", { amount: amountToProcess }))
    : (profile.id === childDetails?.id
        ? (subscriptionType === "true_mindsets_monthly"
            ? t("messages.subscription.trueMindsetsAnnualMonthly", { amount: amountToProcess })
            : t("messages.subscription.trueMindsetsAnnual", { amount: amountToProcess }))
        : t("messages.subscription.trueMindsetsAnnualMonthlyChild", { amount: amountToProcess }));

  return (
    <Dialog open={openPaymentModal} fullWidth maxWidth="sm"
      PaperProps={{ sx: { borderRadius: "24px", overflow: "hidden" } }}>

      <MDBox onClick={() => handleClosePaymentModal("pending")} sx={circleCloseSx}>
        <Icon sx={{ fontSize: "18px !important", color: palette.neutral[600] }}>close</Icon>
      </MDBox>

      <MDBox sx={{ px: 4, pt: 5, pb: 1, textAlign: "center" }}>
        <MDBox sx={{ width: 72, height: 72, borderRadius: "50%", bgcolor: palette.green[50], display: "flex", alignItems: "center", justifyContent: "center", mx: "auto", mb: 2 }}>
          <Icon sx={{ fontSize: "36px !important", color: palette.green[500] }}>payment</Icon>
        </MDBox>
        <MDTypography variant="h5" fontWeight="bold" mb={0.75}>{t("headings.maxuPayment")}</MDTypography>
        <MDTypography variant="body2" color="text.secondary" mb={0}>{feeLabel}</MDTypography>
      </MDBox>

      <DialogContent>
        {!proceedToPayment && (
          <Coupon
            setAmountToProcess={setAmountToProcess}
            setProceedtoPayment={setProceedtoPayment}
            handleClosePaymentModal={handleClosePaymentModal}
            childDetails={childDetails}
            setCouponUsed={setCouponUsed}
            subscriptionType={subscriptionType}
          />
        )}
        {proceedToPayment && (
          <Payment
            childDetails={childDetails}
            handleClosePaymentModal={handleClosePaymentModal}
            amountToProcess={amountToProcess}
            couponUsed={couponUsed}
            subscriptionType={subscriptionType}
          />
        )}
      </DialogContent>
    </Dialog>
  );
};

const AddChildModal = ({
  openAddChildModal,
  handleCloseAddChildModal,
  getChildrens,
  updateUserProfile,
  handleOpenPaymentModal,
  handleOpenInstructionModal,
  setOpenAddChildModal,
  profile,
  setOpenSnackbar,
  setAlertMessage,
  setSeverity,
  t,
}) => {
  // const [addChild, setAddChild] = useState({
  //   name: "",
  //   lastName:"",
  //   email: "",
  //   gender: "Male",
  //   dob: "",
  //   status: "inactive",
  // });
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [gender, setGender] = useState("Male");
  const [dob, setDob] = useState(null);

  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [termsConditionsChecked, setTermsConditionsChecked] = useState(false);
  const [paymentTermsChecked, setPaymentTermsChecked] = useState(false);

  useEffect(() => {
    let today = new Date();
    // Parents can add childrens above 12  and below 18 only
    // Giving  limit to the date picker acording to that dates only.
    // if today is MAY-15-2023 start date will be MAY-16-2005(below 18) end date will be MAY-15-2011 (above 12 years)

    let end_date = new Date(
      today.getFullYear() - 8,
      today.getMonth(),
      today.getDate(),
      today.getHours(),
      today.getMinutes(),
      today.getSeconds()
    );
    setEndDate(end_date.toISOString().slice(0, 10));
    let start_date = new Date(
      today.getFullYear() - 18,
      today.getMonth(),
      today.getDate() + 1,
      today.getHours(),
      today.getMinutes(),
      today.getSeconds()
    );
    setStartDate(start_date.toISOString().slice(0, 10));
  }, []);
  // const onChangeAddChildHandler = (e) => {
  //   setAddChild({ ...addChild, [e.target.name]: e.target.value });
  // };

  const addChildSubmitHandler = (e) => {
    setIsLoading(true);
    e.preventDefault();
    const currentDate = new Date();
    const nameValue = firstName + " " + lastName;
    const body = {
      email: email,
      phone: null,
      relationships: {
        parents: [profile.id],
      },
      type: ["Learner"],
      language: profile.language ? profile.language : "en",
      is_demo_user: false,
      status: "inactive",
      true_mindsets: profile.true_mindsets ? true : false,
      source: profile.source,
      details: {
        name: nameValue,
        dob: dob,
        persona: ["Athlete"],
        gender: gender,
        address: {
          street: null,
          city: null,
          state: null,
          country: null,
          zip: null,
        },
      },
      payment_status: "pending",
      profile_image_url: null,
      identities: [
        {
          google: {
            id: "",
          },
          facebook: {
            id: "",
          },
          apple: {
            id: "",
          },
          amazon: {
            id: "",
          },
          email: {
            id: "",
          },
        },
      ],
    };
    call("users", "POST", {
      body: body,
      params: { add_as: "parent" },
      headers: { "Content-Type": "application/json" },
    })
      .then((response) => {
        if (response) {
          if (response.status == 403 || response.status == 404 || response.status == 400) {
            setSeverity("error");
            setOpenSnackbar(true);
            setOpenAddChildModal(false);
            setAlertMessage(response.data.message);
          } else if (response.status == 200) {
            console.log("response", response.data);
            setSeverity("success");
            setOpenSnackbar(true);
            setAlertMessage(t("alerts.profile.childAddedSuccessfully"));
            getChildrens();
            updateUserProfile();
            if (response.data) {
              handleOpenPaymentModal(response.data);
            }
            setIsLoading(false);
          } else if (response.status == 440) {
            setOpenAddChildModal(false);
          } else {
            setSeverity("error");
            setOpenSnackbar(true);
            setAlertMessage(t("alerts.profile.childAddedError"));
          }
        } else {
          setIsLoading(false);
        }
      })
      .catch((err) => {
        Sentry.captureException(err);
        setOpenAddChildModal(false);
        setIsLoading(false);
        console.log(err, "err");
      });
  };

  const termsConditionsCheckboxHandler = () => {
    setTermsConditionsChecked(!termsConditionsChecked);
  };

  const paymentTermsCheckboxHandler = () => {
    setPaymentTermsChecked(!paymentTermsChecked);
  };

  return (
    <Dialog open={openAddChildModal} onClose={handleCloseAddChildModal} fullWidth maxWidth="sm"
      PaperProps={{ sx: { borderRadius: "24px", overflow: "hidden", maxHeight: "95vh" } }}>

      <MDBox onClick={handleCloseAddChildModal} sx={circleCloseSx}>
        <Icon sx={{ fontSize: "18px !important", color: palette.neutral[600] }}>close</Icon>
      </MDBox>

      <MDBox sx={{ overflowY: "auto" }}>
        <MDBox sx={{ px: 4, pt: 5, pb: 4 }}>
          <MDBox textAlign="center" mb={3}>
            <MDBox sx={{ width: 80, height: 80, borderRadius: "50%", bgcolor: palette.brand[50], display: "flex", alignItems: "center", justifyContent: "center", mx: "auto", mb: 2 }}>
              <Icon sx={{ fontSize: "40px !important", color: palette.brand[500] }}>supervisor_account</Icon>
            </MDBox>
            <MDTypography variant="h5" fontWeight="bold" mb={0.5}>{t("headings.addLearner")}</MDTypography>
            <MDTypography variant="body2" color="text.secondary">{t("messages.profile.addAsParent")}</MDTypography>
          </MDBox>

          <form onSubmit={addChildSubmitHandler}>
            <MDBox mb={2}>
              <MDTypography variant="body2" fontWeight="bold" mb={0.75}>{t("formLabels.firstName")} <span style={{ color: "#f44336" }}>*</span></MDTypography>
              <TextField fullWidth size="small" value={firstName} placeholder={t("formPlaceHolders.firstName")} required sx={addFormSx}
                onChange={(e) => { if (e.nativeEvent.data != " ") setFirstName(e.target.value); }} />
            </MDBox>
            <MDBox mb={2}>
              <MDTypography variant="body2" fontWeight="bold" mb={0.75}>{t("formLabels.lastName")} <span style={{ color: "#f44336" }}>*</span></MDTypography>
              <TextField fullWidth size="small" value={lastName} placeholder={t("formPlaceHolders.lastName")} required sx={addFormSx}
                onChange={(e) => { if (e.nativeEvent.data != " ") setLastName(e.target.value); }} />
            </MDBox>
            <MDBox mb={2}>
              <MDTypography variant="body2" fontWeight="bold" mb={0.75}>{t("formLabels.email")} <span style={{ color: "#f44336" }}>*</span></MDTypography>
              <TextField fullWidth size="small" value={email} type="email" placeholder={t("formPlaceHolders.email")} required sx={addFormSx}
                onChange={(e) => { if (e.nativeEvent.data != " ") setEmail(e.target.value); }} />
            </MDBox>


            <MDBox mb={2}>
              <MDTypography variant="body2" fontWeight="bold" mb={0.75}>{t("formLabels.gender")} <span style={{ color: "#f44336" }}>*</span></MDTypography>
              <FormControl fullWidth size="small">
                <Select value={gender} onChange={(e) => setGender(e.target.value)} sx={selectSx}>
                  <MenuItem value="Male">{t("formLabels.male")}</MenuItem>
                  <MenuItem value="Female">{t("formLabels.female")}</MenuItem>
                </Select>
              </FormControl>
            </MDBox>
            <MDBox mb={2.5}>
              <MDTypography variant="body2" fontWeight="bold" mb={0.75}>{t("formLabels.birthdate")} <span style={{ color: "#f44336" }}>*</span></MDTypography>
              <TextField type="date" fullWidth size="small" value={dob} required sx={addFormSx}
                inputProps={{ min: startDate, max: endDate }} onChange={(e) => setDob(e.target.value)} />
            </MDBox>

            <MDBox sx={{ bgcolor: palette.neutral[50], border: `1px solid ${palette.neutral[200]}`, borderRadius: "12px", p: 2, mb: 3 }}>
              <FormGroup>
                <FormControlLabel
                  control={<Checkbox required size="small" checked={termsConditionsChecked} onChange={termsConditionsCheckboxHandler} />}
                  label={<MDTypography variant="caption"><span style={{ color: "#f44336" }}>* </span>{t("formLabels.termsAndConditions")}{" "}<Typography component="a" fontSize={12} sx={{ color: palette.brand[500] }} href="/terms_conditions" target="_blank">{t("formLabels.terms")}</Typography></MDTypography>}
                />
                <FormControlLabel
                  control={<Checkbox required size="small" checked={paymentTermsChecked} onChange={paymentTermsCheckboxHandler} />}
                  label={<MDTypography variant="caption"><span style={{ color: "#f44336" }}>* </span>{t("formLabels.termsAndConditions")}{" "}<Typography component="a" fontSize={12} sx={{ color: palette.brand[500] }} href="/payment_terms" target="_blank">{t("formLabels.paymentTerms")}</Typography></MDTypography>}
                />
              </FormGroup>
            </MDBox>

            <MDBox display="flex" gap={2}>
              <MDButton variant="outlined" fullWidth onClick={handleCloseAddChildModal}
                sx={{ borderRadius: "12px", py: 1.5, textTransform: "none", borderColor: palette.neutral[300], color: palette.neutral[600], fontWeight: "bold" }}>
                {t("buttonTitles.cancel") || "Cancel"}
              </MDButton>
              <MDButton type="submit" variant="contained" fullWidth disabled={isLoading}
                sx={{ borderRadius: "12px", py: 1.5, textTransform: "none", bgcolor: palette.brand[500], color: "#fff", fontWeight: "bold", "&:hover": { bgcolor: palette.brand[600] } }}>
                {isLoading ? <CircularProgress size={20} color="inherit" /> : t("buttonTitles.next")}
              </MDButton>
            </MDBox>
          </form>
        </MDBox>
      </MDBox>
    </Dialog>
  );
};

const AddAthleteModal = ({
  openAddAthleteModal,
  handleCloseAddAthleteModal,
  getChildrens,
  updateUserProfile,
  handleOpenPaymentModal,
  handleOpenInstructionModal,
  setOpenAddAthleteModal,
  profile,
  setOpenSnackbar,
  setAlertMessage,
  setSeverity,
  t,
}) => {
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [parentEmail, setParentEmail] = useState("");
  const [gender, setGender] = useState("Male");
  const [dob, setDob] = useState("");

  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [termsConditionsChecked, setTermsConditionsChecked] = useState(false);
  const [paymentTermsChecked, setPaymentTermsChecked] = useState(false);

  // Calculate age from dob
  const calculateAge = (birthDate) => {
    if (!birthDate) return null;
    const diff_ms = Date.now() - new Date(birthDate).getTime();
    const age_dt = new Date(diff_ms);
    return Math.abs(age_dt.getUTCFullYear() - 1970);
  };

  const userAge = calculateAge(dob);
  const isMinor = userAge !== null && userAge < 18;
  const emailsMatch = email && parentEmail && email.toLowerCase() === parentEmail.toLowerCase();

  useEffect(() => {
    let today = new Date();
    // Coaches can add Athlete above 8
    // Giving  limit to the date picker acording to that dates only.
    // if today is MAY-15-2023 start date will be MAY-16-2005(below 18) end date will be MAY-15-2011 (above 12 years)
    let end_date = new Date(
      today.getFullYear() - 8,
      today.getMonth(),
      today.getDate(),
      today.getHours(),
      today.getMinutes(),
      today.getSeconds()
    );
    setEndDate(end_date.toISOString().slice(0, 10));
  }, []);

  const handleApiResponse = (response) => {
    if (response) {
      if (response.status == 403 || response.status == 404 || response.status == 400) {
        setSeverity("error");
        setOpenSnackbar(true);
        setOpenAddAthleteModal(false);
        setAlertMessage(response.data.message);
      } else if (response.status == 200) {
        setSeverity("success");
        setOpenSnackbar(true);
        setAlertMessage(t("alerts.profile.childAddedSuccessfully"));
        getChildrens();
        updateUserProfile();
        handleOpenPaymentModal(response.data);
        setIsLoading(false);
      } else if (response.status == 440) {
        setOpenAddAthleteModal(false);
      } else {
        setSeverity("error");
        setOpenSnackbar(true);
        setAlertMessage(t("alerts.profile.childAddedError"));
      }
    } else {
      setIsLoading(false);
    }
  };

  const handleApiError = (err) => {
    Sentry.captureException(err);
    setOpenAddAthleteModal(false);
    setIsLoading(false);
    console.log(err, "err");
  };

  const addAthleteSubmitHandler = (e) => {
    e.preventDefault();
    if (emailsMatch) return;
    setIsLoading(true);
    const nameValue = firstName + " " + lastName;
    const user_age = calculateAge(dob);

    const learnerDetails = {
      name: nameValue,
      dob: dob,
      gender: gender,
      persona: ["Athlete"],
    };

    // Case 1: User is 18+ (Adult) - original flow
    if (user_age >= 18) {
      const body = {
        email: email,
        phone: null,
        relationships: {
          coaches: [profile.id],
          children: [],
        },
        type: ["Learner", "Adult"],
        language: profile.language ? profile.language : "en",
        is_demo_user: false,
        true_mindsets: profile.true_mindsets ? true : false,
        source: profile.source,
        status: "inactive",
        details: {
          ...learnerDetails,
          address: {
            street: null,
            city: null,
            state: null,
            country: null,
            zip: null,
          },
        },
        payment_status: "pending",
        profile_image_url: null,
        identities: [
          {
            google: { id: "" },
            facebook: { id: "" },
            apple: { id: "" },
            amazon: { id: "" },
            email: { id: "" },
          },
        ],
      };

      call("users", "POST", {
        body: body,
        params: { add_as: "coach" },
        headers: { "Content-Type": "application/json" },
      })
        .then(handleApiResponse)
        .catch(handleApiError);
    }
    // Case 2: Minor with only learner email (no parent email) - original flow for minors
    else if (email && !parentEmail) {
      const body = {
        email: email,
        phone: null,
        relationships: {
          coaches: [profile.id],
        },
        type: ["Learner"],
        language: profile.language ? profile.language : "en",
        is_demo_user: false,
        true_mindsets: profile.true_mindsets ? true : false,
        source: profile.source,
        status: "inactive",
        details: {
          ...learnerDetails,
          address: {
            street: null,
            city: null,
            state: null,
            country: null,
            zip: null,
          },
        },
        payment_status: "pending",
        profile_image_url: null,
        identities: [
          {
            google: { id: "" },
            facebook: { id: "" },
            apple: { id: "" },
            amazon: { id: "" },
            email: { id: "" },
          },
        ],
      };

      call("users", "POST", {
        body: body,
        params: { add_as: "coach" },
        headers: { "Content-Type": "application/json" },
      })
        .then(handleApiResponse)
        .catch(handleApiError);
    }
    // Case 3: Minor with only parent email - create shared account
    else if (parentEmail && !email) {
      const body = {
        email: parentEmail,
        phone: null,
        relationships: {
          coaches: [profile.id],
          children: [],
        },
        type: ["Learner", "Shared"],
        language: profile.language ? profile.language : "en",
        is_demo_user: false,
        true_mindsets: profile.true_mindsets ? true : false,
        source: profile.source,
        status: "inactive",
        details: {
          name: null,
          address: {},
          dob: null,
          gender: null,
          persona: ["Parent"],
          learner_details: learnerDetails,
        },
        payment_status: "pending",
        profile_image_url: null,
        identities: [
          {
            google: { id: "" },
            facebook: { id: "" },
            apple: { id: "" },
            amazon: { id: "" },
            email: { id: "" },
          },
        ],
      };

      call("users", "POST", {
        body: body,
        params: { add_as: "coach", account_type: "shared" },
        headers: { "Content-Type": "application/json" },
      })
        .then(handleApiResponse)
        .catch(handleApiError);
    }
    // Case 4: Minor with both learner and parent email - create separate accounts with shared relation
    else if (email && parentEmail) {
      const body = {
        email: email,
        parent_email: parentEmail,
        phone: null,
        relationships: {
          coaches: [profile.id],
          parents: [],
        },
        type: ["Learner"],
        language: profile.language ? profile.language : "en",
        is_demo_user: false,
        true_mindsets: profile.true_mindsets ? true : false,
        source: profile.source,
        status: "inactive",
        details: {
          ...learnerDetails,
          address: {
            street: null,
            city: null,
            state: null,
            country: null,
            zip: null,
          },
        },
        payment_status: "pending",
        profile_image_url: null,
        identities: [
          {
            google: { id: "" },
            facebook: { id: "" },
            apple: { id: "" },
            amazon: { id: "" },
            email: { id: "" },
          },
        ],
      };

      call("users", "POST", {
        body: body,
        params: { add_as: "coach", account_type: "separate" },
        headers: { "Content-Type": "application/json" },
      })
        .then(handleApiResponse)
        .catch(handleApiError);
    }
  };

  const termsConditionsCheckboxHandler = () => {
    setTermsConditionsChecked(!termsConditionsChecked);
  };

  const paymentTermsCheckboxHandler = () => {
    setPaymentTermsChecked(!paymentTermsChecked);
  };

  return (
    <Dialog open={openAddAthleteModal} onClose={handleCloseAddAthleteModal} fullWidth maxWidth="sm"
      PaperProps={{ sx: { borderRadius: "24px", overflow: "hidden", maxHeight: "95vh" } }}>

      <MDBox onClick={handleCloseAddAthleteModal} sx={circleCloseSx}>
        <Icon sx={{ fontSize: "18px !important", color: palette.neutral[600] }}>close</Icon>
      </MDBox>

      <MDBox sx={{ overflowY: "auto" }}>
        <MDBox sx={{ px: 4, pt: 5, pb: 4 }}>
          <MDBox textAlign="center" mb={3}>
            <MDBox sx={{ width: 80, height: 80, borderRadius: "50%", bgcolor: "#4caf5018", display: "flex", alignItems: "center", justifyContent: "center", mx: "auto", mb: 2 }}>
              <Icon sx={{ fontSize: "40px !important", color: "#4caf50" }}>sports</Icon>
            </MDBox>
            <MDTypography variant="h5" fontWeight="bold" mb={0.5}>{t("headings.addLearner")}</MDTypography>
            <MDTypography variant="body2" color="text.secondary">{t("messages.profile.addAsCoach")}</MDTypography>
          </MDBox>

          <form onSubmit={addAthleteSubmitHandler}>
            <MDBox mb={2}>
              <MDTypography variant="body2" fontWeight="bold" mb={0.75}>{t("formLabels.firstName")} <span style={{ color: "#f44336" }}>*</span></MDTypography>
              <TextField fullWidth size="small" value={firstName} placeholder={t("formPlaceHolders.firstName")} required sx={addFormSx}
                onChange={(e) => { if (e.nativeEvent.data != " ") setFirstName(e.target.value); }} />
            </MDBox>
            <MDBox mb={2}>
              <MDTypography variant="body2" fontWeight="bold" mb={0.75}>{t("formLabels.lastName")} <span style={{ color: "#f44336" }}>*</span></MDTypography>
              <TextField fullWidth size="small" value={lastName} placeholder={t("formPlaceHolders.lastName")} required sx={addFormSx}
                onChange={(e) => { if (e.nativeEvent.data != " ") setLastName(e.target.value); }} />
            </MDBox>
            <MDBox mb={2}>
              <MDTypography variant="body2" fontWeight="bold" mb={0.75}>{t("formLabels.gender")} <span style={{ color: "#f44336" }}>*</span></MDTypography>
              <FormControl fullWidth size="small">
                <Select value={gender} onChange={(e) => setGender(e.target.value)} sx={selectSx}>
                  <MenuItem value="Male">{t("formLabels.male")}</MenuItem>
                  <MenuItem value="Female">{t("formLabels.female")}</MenuItem>
                </Select>
              </FormControl>
            </MDBox>
            <MDBox mb={2}>
              <MDTypography variant="body2" fontWeight="bold" mb={0.75}>{t("formLabels.birthdate")} <span style={{ color: "#f44336" }}>*</span></MDTypography>
              <TextField type="date" fullWidth size="small" value={dob} required sx={addFormSx}
                inputProps={{ min: startDate, max: endDate }}
                onChange={(e) => { setDob(e.target.value); setEmail(""); setParentEmail(""); }} />
            </MDBox>

            {/* 18+ — single learner email */}
            {dob && !isMinor && (
              <MDBox mb={2}>
                <MDTypography variant="body2" fontWeight="bold" mb={0.75}>{t("formLabels.learnerEmail")} <span style={{ color: "#f44336" }}>*</span></MDTypography>
                <TextField fullWidth size="small" value={email} type="email" placeholder={t("formPlaceHolders.email")} required sx={addFormSx}
                  onChange={(e) => { if (e.nativeEvent.data != " ") setEmail(e.target.value); }} />
              </MDBox>
            )}

            {/* Minor — learner email OR parent email */}
            {dob && isMinor && (
              <MDBox sx={{ bgcolor: palette.neutral[50], border: `1px solid ${palette.neutral[200]}`, borderRadius: "12px", p: 2, mb: 2 }}>
                <MDTypography variant="body2" fontWeight="bold" mb={0.5}>{t("formLabels.email")} <span style={{ color: "#f44336" }}>*</span></MDTypography>
                <MDTypography variant="caption" color="text.secondary" display="block" mb={1.5} sx={{ fontStyle: "italic" }}>
                  {t("formLabels.minorEmailNote")}
                </MDTypography>
                <MDTypography variant="caption" fontWeight="bold" display="block" mb={0.5}>{t("formLabels.learnerEmail")}</MDTypography>
                <TextField fullWidth size="small" value={email} type="email" placeholder={t("formPlaceHolders.email")} required={!parentEmail} sx={addFormSx}
                  onChange={(e) => { if (e.nativeEvent.data != " ") setEmail(e.target.value); }} />
                <MDTypography variant="caption" fontWeight="bold" display="block" mt={1.5} mb={0.5}>
                  <span style={{ color: "text.secondary", fontStyle: "italic", marginRight: 4 }}>({t("formLabels.or")})</span>
                  {t("formLabels.parentEmail")}
                </MDTypography>
                <TextField fullWidth size="small" value={parentEmail} type="email" placeholder={t("formPlaceHolders.parentEmail")} required={!email} error={!!emailsMatch} sx={addFormSx}
                  onChange={(e) => { if (e.nativeEvent.data != " ") setParentEmail(e.target.value); }} />
                {emailsMatch && <MDTypography variant="caption" color="error" display="block" mt={0.5}>{t("formLabels.emailsMustBeDifferent")}</MDTypography>}
              </MDBox>
            )}

            <MDBox sx={{ bgcolor: palette.neutral[50], border: `1px solid ${palette.neutral[200]}`, borderRadius: "12px", p: 2, mb: 3 }}>
              <FormGroup>
                <FormControlLabel
                  control={<Checkbox required size="small" checked={termsConditionsChecked} onChange={termsConditionsCheckboxHandler} />}
                  label={<MDTypography variant="caption"><span style={{ color: "#f44336" }}>* </span>{t("formLabels.termsAndConditions")}{" "}<Typography component="a" fontSize={12} sx={{ color: palette.brand[500] }} href="/terms_conditions" target="_blank">{t("formLabels.terms")}</Typography></MDTypography>}
                />
                <FormControlLabel
                  control={<Checkbox required size="small" checked={paymentTermsChecked} onChange={paymentTermsCheckboxHandler} />}
                  label={<MDTypography variant="caption"><span style={{ color: "#f44336" }}>* </span>{t("formLabels.termsAndConditions")}{" "}<Typography component="a" fontSize={12} sx={{ color: palette.brand[500] }} href="/payment_terms" target="_blank">{t("formLabels.paymentTerms")}</Typography></MDTypography>}
                />
              </FormGroup>
            </MDBox>

            <MDBox display="flex" gap={2}>
              <MDButton variant="outlined" fullWidth onClick={handleCloseAddAthleteModal}
                sx={{ borderRadius: "12px", py: 1.5, textTransform: "none", borderColor: palette.neutral[300], color: palette.neutral[600], fontWeight: "bold" }}>
                {t("buttonTitles.cancel") || "Cancel"}
              </MDButton>
              <MDButton type="submit" variant="contained" fullWidth
                disabled={(isMinor && !email && !parentEmail) || !!emailsMatch || isLoading}
                sx={{ borderRadius: "12px", py: 1.5, textTransform: "none", bgcolor: palette.brand[500], color: "#fff", fontWeight: "bold", "&:hover": { bgcolor: palette.brand[600] }, "&.Mui-disabled": { bgcolor: palette.neutral[300], color: "#fff" } }}>
                {isLoading ? <CircularProgress size={20} color="inherit" /> : t("buttonTitles.next")}
              </MDButton>
            </MDBox>
          </form>
        </MDBox>
      </MDBox>
    </Dialog>
  );
};

const EditChildModal = ({
  openEditModal,
  handleCloseEditModal,
  editChildData,
  getChildrens,
  setAlertMessage,
  setOpenSnackbar,
  setSeverity,
  t,
}) => {
  const [editChild, setEditChild] = useState({ name: "", gender: "", dob: "" });
  const isSharedEdit = editChildData.type && editChildData.type.includes("Shared");
  const editDetails =
    isSharedEdit && editChildData.details.learner_details
      ? editChildData.details.learner_details
      : editChildData.details;
  const [firstName, setFirstName] = useState(editDetails.name.split(" ")[0]);
  const [lastName, setLastName] = useState(editDetails.name.split(" ")[1] ?? null);
  const [gender, setGender] = useState(editDetails.gender);
  const [dob, setDob] = useState(editDetails.dob);
  const [isLoading, setIsLoading] = useState(false);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  useEffect(() => {
    let year = 8;
    if (editChildData.relation == "Child") {
      year = 8;
    }
    let today = new Date();
    let end_date = new Date(
      today.getFullYear() - year,
      today.getMonth(),
      today.getDate(),
      today.getHours(),
      today.getMinutes(),
      today.getSeconds()
    );
    setEndDate(end_date.toISOString().slice(0, 10));
    // setEndDate(today.toISOString().slice(0, 10));
    let start_date = new Date(
      today.getFullYear() - 18,
      today.getMonth(),
      today.getDate() + 1,
      today.getHours(),
      today.getMinutes(),
      today.getSeconds()
    );
    setStartDate(start_date.toISOString().slice(0, 10));
  }, []);

  const editHandler = (e) => {
    e.preventDefault();
    setIsLoading(true);
    if (isSharedEdit && editChildData.details.learner_details) {
      editChildData.details.learner_details.name = firstName + " " + lastName;
      editChildData.details.learner_details.gender = gender;
      editChildData.details.learner_details.dob = dob;
    } else {
      editChildData.details.name = firstName + " " + lastName;
      editChildData.details.gender = gender;
      editChildData.details.dob = dob;
    }

    call(`users/${editChildData.id}`, "PUT", {
      body: editChildData,
      headers: { "Content-Type": "application/json" },
    })
      .then((response) => {
        if (response.status == 200) {
          setSeverity("success");
          setOpenSnackbar(true);
          setAlertMessage(t("alerts.profile.childUpdatedSuccessfully"));
          setIsLoading(false);
          handleCloseEditModal();
          getChildrens();
        } else if (response.status == 403 || response.status == 404 || response.status == 400) {
          setSeverity("error");
          setOpenSnackbar(true);
          setAlertMessage(t("alerts.profile.childUpdatedError"));
          setIsLoading(false);
          handleCloseEditModal();
          getChildrens();
        } else if (response.status == 440) {
          setIsLoading(false);
          handleCloseEditModal();
        }
      })
      .catch(function (error) {
        Sentry.captureException(error);
        setSeverity("error");
        setOpenSnackbar(true);
        setAlertMessage(t("alerts.profile.childUpdatedError"));
        setIsLoading(false);
        handleCloseEditModal();
        console.log(error);
      });
  };
  const editFieldSx = { "& .MuiOutlinedInput-root": { borderRadius: "12px", bgcolor: "#fafafa" } };

  return (
    <Dialog open={openEditModal} onClose={handleCloseEditModal} fullWidth maxWidth="xs"
      PaperProps={{ sx: { borderRadius: "24px", overflow: "hidden" } }}>

      {/* Circle close */}
      <MDBox onClick={handleCloseEditModal} sx={{ position: "absolute", top: 12, right: 12, zIndex: 10, width: 36, height: 36, borderRadius: "50%", bgcolor: palette.neutral[100], border: `1px solid ${palette.neutral[200]}`, display: "flex", alignItems: "center", justifyContent: "center", cursor: "pointer", "&:hover": { bgcolor: palette.neutral[200] } }}>
        <Icon sx={{ fontSize: "18px !important", color: palette.neutral[600] }}>close</Icon>
      </MDBox>

      <MDBox sx={{ px: 4, pt: 5, pb: 4 }}>
        {/* Header */}
        <MDBox textAlign="center" mb={3}>
          <MDBox sx={{ width: 80, height: 80, borderRadius: "50%", bgcolor: palette.brand[50], display: "flex", alignItems: "center", justifyContent: "center", mx: "auto", mb: 2 }}>
            <Icon sx={{ fontSize: "40px !important", color: palette.brand[500] }}>edit_note</Icon>
          </MDBox>
          <MDTypography variant="h5" fontWeight="bold" mb={0.5}>{t("headings.editLearner")}</MDTypography>
          <MDTypography variant="body2" color="text.secondary">Update learner information</MDTypography>
        </MDBox>

        <form onSubmit={editHandler}>
          {/* First Name */}
          <MDBox mb={2.5}>
            <MDTypography variant="body2" fontWeight="bold" mb={0.75}>
              {t("formLabels.firstName")} <span style={{ color: "#f44336" }}>*</span>
            </MDTypography>
            <TextField fullWidth size="small" value={firstName} placeholder={t("formPlaceHolders.firstName")} required sx={editFieldSx}
              onChange={(e) => { if (e.nativeEvent.data != " ") setFirstName(e.target.value); }} />
          </MDBox>

          {/* Last Name */}
          <MDBox mb={2.5}>
            <MDTypography variant="body2" fontWeight="bold" mb={0.75}>
              {t("formLabels.lastName")} <span style={{ color: "#f44336" }}>*</span>
            </MDTypography>
            <TextField fullWidth size="small" value={lastName} placeholder={t("formPlaceHolders.lastName")} required sx={editFieldSx}
              onChange={(e) => { if (e.nativeEvent.data != " ") setLastName(e.target.value); }} />
          </MDBox>

          {/* Gender */}
          <MDBox mb={2.5}>
            <MDTypography variant="body2" fontWeight="bold" mb={0.75}>
              {t("formLabels.gender")} <span style={{ color: "#f44336" }}>*</span>
            </MDTypography>
            <FormControl fullWidth>
              <Select value={gender} onChange={(e) => setGender(e.target.value)} name="gender"
                sx={{
                  borderRadius: "12px", bgcolor: "#fafafa", height: "40px",
                  "& .MuiOutlinedInput-notchedOutline": { borderColor: "rgba(0,0,0,0.23)" },
                  "&:hover .MuiOutlinedInput-notchedOutline": { borderColor: "rgba(0,0,0,0.87)" },
                  "&.Mui-focused .MuiOutlinedInput-notchedOutline": { borderColor: palette.brand[500] },
                }}>
                <MenuItem value="Male">{t("formLabels.male")}</MenuItem>
                <MenuItem value="Female">{t("formLabels.female")}</MenuItem>
              </Select>
            </FormControl>
          </MDBox>

          {/* Date of Birth */}
          <MDBox mb={3.5}>
            <MDTypography variant="body2" fontWeight="bold" mb={0.75}>
              {t("formLabels.birthdate")} <span style={{ color: "#f44336" }}>*</span>
            </MDTypography>
            <TextField type="date" fullWidth size="small" required value={dob} sx={editFieldSx}
              inputProps={{ min: startDate, max: endDate }}
              onChange={(e) => setDob(e.target.value)} />
          </MDBox>

          {/* Buttons */}
          <MDBox display="flex" gap={2}>
            <MDButton variant="outlined" fullWidth onClick={handleCloseEditModal}
              sx={{ borderRadius: "12px", py: 1.5, textTransform: "none", borderColor: palette.neutral[300], color: palette.neutral[600], fontWeight: "bold" }}>
              {t("buttonTitles.cancel") || "Cancel"}
            </MDButton>
            <MDButton type="submit" variant="contained" fullWidth disabled={isLoading}
              sx={{ borderRadius: "12px", py: 1.5, textTransform: "none", bgcolor: palette.brand[500], color: "#fff", fontWeight: "bold", "&:hover": { bgcolor: palette.brand[600] }, "&.Mui-disabled": { bgcolor: palette.neutral[300], color: "#fff" } }}>
              {isLoading ? <CircularProgress size={20} color="inherit" /> : t("buttonTitles.saveChanges")}
            </MDButton>
          </MDBox>
        </form>
      </MDBox>
    </Dialog>
  );
};

const DeleteChildModal = ({
  openDeleteModal,
  handleCloseDeleteModal,
  getChildrens,
  updateUserProfile,
  deleteChildId,
  setAlertMessage,
  setOpenSnackbar,
  setSeverity,
  t,
}) => {
  const deleteHandler = () => {
    call(`users/${deleteChildId}`, "DELETE", { params: { type: "children" } })
      .then((response) => {
        if (response.status == 200) {
          getChildrens();
          updateUserProfile();
          setSeverity("success");
          setOpenSnackbar(true);
          setAlertMessage(t("alerts.profile.childDeletedSuccessfully"));
          handleCloseDeleteModal();
        } else if (response.status == 440) {
          handleCloseDeleteModal();
        } else {
          setSeverity("error");
          setOpenSnackbar(true);
          setAlertMessage(t("alerts.profile.childDeletedError"));
        }
      })
      .catch(function (error) {
        Sentry.captureException(error);
        setSeverity("error");
        setOpenSnackbar(true);
        setAlertMessage(t("alerts.profile.childDeletedError"));
        handleCloseDeleteModal();
        console.log(error);
      });
  };
  return (
    <Dialog open={openDeleteModal} onClose={handleCloseDeleteModal}>
      <CloseIcon
        fontSize="medium"
        onClick={handleCloseDeleteModal}
        style={{ color: "red", display: "block", marginLeft: "auto", cursor: "pointer" }}
      />
      <DialogTitle>
        <Typography variant="h4" mb={1}>
          {t("headings.removeChild")}
        </Typography>
      </DialogTitle>
      <DialogContent>
        <Typography variant="string" mb={1}>
          {t("messages.profile.removeChild")}
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={() => deleteHandler()}
          style={{
            marginTop: "15px",
            color: "white",
            background: "red",
          }}
        >
          {t("buttonTitles.remove")}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

const PaymentSuccessModal = ({ openPaymentSuccessModal, handleClosePaymentSuccessModal, t }) => {
  return (
    <Dialog open={openPaymentSuccessModal} onClose={() => handleClosePaymentSuccessModal()} fullWidth maxWidth="xs"
      PaperProps={{ sx: { borderRadius: "24px", overflow: "hidden" } }}>

      <MDBox onClick={() => handleClosePaymentSuccessModal()} sx={circleCloseSx}>
        <Icon sx={{ fontSize: "18px !important", color: palette.neutral[600] }}>close</Icon>
      </MDBox>

      <MDBox sx={{ px: 4, pt: 5, pb: 4, textAlign: "center" }}>
        <MDBox sx={{ position: "relative", display: "inline-flex", mb: 3 }}>
          <MDBox sx={{ position: "absolute", top: -10, left: -18, color: "#4caf50", fontSize: "18px", lineHeight: 1 }}>✦</MDBox>
          <MDBox sx={{ position: "absolute", bottom: -8, right: -16, color: "#4caf50", fontSize: "14px", lineHeight: 1 }}>✦</MDBox>
          <MDBox sx={{ position: "absolute", bottom: 0, left: -12, color: "#f48326", fontSize: "10px", lineHeight: 1 }}>●</MDBox>
          <MDBox sx={{ position: "absolute", top: 2, right: -20, color: "#9c27b0", fontSize: "10px", lineHeight: 1 }}>●</MDBox>
          <MDBox sx={{ width: 90, height: 90, borderRadius: "50%", bgcolor:  palette.green[50], display: "flex", alignItems: "center", justifyContent: "center" }}>
            <Icon sx={{ fontSize: "48px !important", color: palette.green[500] }}>check_circle</Icon>
          </MDBox>
        </MDBox>

        <MDTypography variant="h5" fontWeight="bold" mb={1}>
          {t("messages.subscription.paymentCompleted")}
        </MDTypography>
        <MDTypography variant="body2" color="text.secondary" mb={3} sx={{ lineHeight: 1.6 }}>
          Your payment was processed successfully. The learner account is now active.
        </MDTypography>

        <MDButton variant="contained" fullWidth onClick={() => handleClosePaymentSuccessModal()}
          sx={{ borderRadius: "12px", py: 1.5, textTransform: "none", bgcolor: palette.brand[500], color: "#fff", fontWeight: "bold", "&:hover": { bgcolor:  palette.brand[700] } }}>
          <Icon sx={{ mr: 1, fontSize: "18px !important" }}>check</Icon>
          {t("buttonTitles.finish")}
        </MDButton>
      </MDBox>
    </Dialog>
  );
};

// Add i18N Translations when we work on this Modal
// const ChildSummaryModal = ({
//   openChildSummaryModal,
//   handleCloseChildSummaryModal,
//   profile,
//   setOpenSnackbar,
//   setAlertMessage,
//   setSeverity,
//   t,
// }) => {
//   const [activity, setActivity] = useState("weekly");
//   const [isLoading, setIsLoading] = useState(false);
//   const data = profile;
//   profile.learner_activity_email = activity;
//   const activityHandler = (e) => {
//     e.preventDefault();
//     setIsLoading(true);
//     call(`users/${profile.id}`, "PUT", {
//       body: data,
//       headers: { "Content-Type": "application/json" },
//     })
//       .then((response) => {
//         if (response.status == 200) {
//           setIsLoading(false);
//           setSeverity("success");
//           setOpenSnackbar(true);
//           setAlertMessage(t("alerts.profile.SubscriptionAddedSuccessfully"));
//           handleCloseChildSummaryModal();
//         } else if (response.status == 403 || response.status == 404 || response.status == 400) {
//           setIsLoading(false);
//           setSeverity("error");
//           setOpenSnackbar(true);
//           setAlertMessage(t("alerts.profile.SubscriptionAddedError"));
//           handleCloseChildSummaryModal();
//         } else if (response.status == 440) {
//           setIsLoading(false);
//           handleCloseChildSummaryModal();
//         }
//       })
//       .catch(function (error) {
//         Sentry.captureException(error);
//         setIsLoading(false);
//         setSeverity("error");
//         setOpenSnackbar(true);
//         setAlertMessage(t("alerts.profile.SubscriptionAddedError"));
//         handleCloseChildSummaryModal();
//       });
//   };
//   return (
//     <Dialog open={openChildSummaryModal} onClose={handleCloseChildSummaryModal}>
//       <CloseIcon
//         fontSize="medium"
//         onClick={handleCloseChildSummaryModal}
//         style={{ color: "red", display: "block", marginLeft: "auto", cursor: "pointer" }}
//       />
//       <DialogTitle>
//         <Typography variant="h4" mb={1}>
//           Learners Actvity Summary
//         </Typography>
//       </DialogTitle>
//       <DialogContent>
//         <form onSubmit={activityHandler}>
//           <Typography variant="text" ma={1}>
//             How often would you like to receive your learners' activity summary:
//           </Typography>
//           <FormControl fullWidth>
//             <Select
//               style={{ height: "48px" }}
//               value={activity}
//               onChange={(e) => setActivity(e.target.value)}
//               name="activity"
//             >
//               <MenuItem value="weekly">Weekly</MenuItem>
//               <MenuItem value="biweekly">Biweekly</MenuItem>
//               <MenuItem value="monthly">Monthly</MenuItem>
//               <MenuItem value="never">Never</MenuItem>
//             </Select>
//           </FormControl>

//           <MDBox display="flex" justifyContent="end">
//             <Button
//               type="submit"
//               style={{
//                 color: "white",
//                 background: palette.brand[500],
//                 marginTop: "15px",
//                 display: "flex",
//                 justifyContent: "end",
//               }}
//             >
//               {isLoading ? <CircularProgress color="white" size={20} /> : "Submit"}
//             </Button>
//           </MDBox>
//         </form>
//       </DialogContent>
//     </Dialog>
//   );
// };

const AddLearnerRolePickerModal = ({ open, onClose, onSelectParent, onSelectCoach, t }) => (
  <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
    <MDBox display="flex" alignItems="center" justifyContent="space-between" px={3} pt={3}>
      <MDBox>
        <MDTypography variant="h5" fontWeight="bold">{t("headings.addLearner")}</MDTypography>
        <MDTypography variant="body2" color="text.secondary" mt={0.5}>
          Choose the option that best describes your role:
        </MDTypography>
      </MDBox>
      <CloseIcon onClick={onClose} sx={{ cursor: "pointer", color: "text.secondary" }} />
    </MDBox>
    <DialogContent sx={{ pb: 1 }}>
      <MDBox display="flex" gap={2} mt={1} flexWrap="wrap">
        {/* Parent card */}
        <MDBox
          onClick={onSelectParent}
          flex={1}
          sx={{
            minWidth: 180, border: `2px solid ${palette.neutral[200]}`, borderRadius: "16px",
            p: 3, textAlign: "center", cursor: "pointer", transition: "all 200ms",
            "&:hover": { borderColor: palette.brand[500], bgcolor: `${palette.brand[500]}08`, transform: "translateY(-2px)" },
          }}
        >
          <MDBox sx={{ width: 64, height: 64, borderRadius: "50%", bgcolor: `${palette.brand[500]}18`, display: "flex", alignItems: "center", justifyContent: "center", mx: "auto", mb: 2 }}>
            <Icon sx={{ fontSize: "32px !important", color: palette.brand[500] }}>supervisor_account</Icon>
          </MDBox>
          <MDTypography variant="subtitle1" fontWeight="bold" mb={0.5}>I am their Parent</MDTypography>
          <MDTypography variant="caption" color="text.secondary">
            Add an athlete to your own account and manage their progress.
          </MDTypography>
        </MDBox>

        {/* Coach card */}
        <MDBox
          onClick={onSelectCoach}
          flex={1}
          sx={{
            minWidth: 180, border: `2px solid ${palette.neutral[200]}`, borderRadius: "16px",
            p: 3, textAlign: "center", cursor: "pointer", transition: "all 200ms",
            "&:hover": { borderColor: palette.orange[500], bgcolor: `${palette.orange[500]}08`, transform: "translateY(-2px)" },
          }}
        >
          <MDBox sx={{ width: 64, height: 64, borderRadius: "50%",  bgcolor: `${palette.orange[500]}18`, display: "flex", alignItems: "center", justifyContent: "center", mx: "auto", mb: 2 }}>
            <Icon sx={{ fontSize: "32px !important", color: palette.orange[500] }}>sports</Icon>
          </MDBox>
          <MDTypography variant="subtitle1" fontWeight="bold" mb={0.5}>I am their Coach</MDTypography>
          <MDTypography variant="caption" color="text.secondary">
            Add an athlete as a coach and manage this program.
          </MDTypography>
        </MDBox>
      </MDBox>

      <MDBox display="flex" alignItems="center" justifyContent="center" gap={0.75} mt={3} mb={1}>
        <Icon sx={{ fontSize: "16px !important", color: "text.disabled" }}>info</Icon>
        <MDTypography variant="caption" color="text.secondary">
          You can always add more learners later
        </MDTypography>
      </MDBox>
    </DialogContent>
  </Dialog>
);

ChildrenTable.defaultProps = {
  childrenDetails: [],
  getChildrens: () => {},
};

ChildrenTable.propTypes = {
  childrenDetails: PropTypes.array,
  getChildrens: PropTypes.func,
};

export default ChildrenTable;
